export function isClarityActive(): boolean {
  return typeof window !== 'undefined' && typeof window.clarity === 'function'
}

export interface ClarityTagsInput {
  userId: string
  isAdmin: boolean
  teacherId: number | string | null | undefined
  entityId: number | string | null | undefined
  entityName: string | null | undefined
  entityType: string | null | undefined
  rootId: number | string | null | undefined
  rootName: string | null | undefined
  entityDegree: string | null | undefined
}

export function deriveRole(input: {
  isAdmin: boolean
  teacherId: number | string | null | undefined
}): string {
  if (input.isAdmin) return 'admin'
  if (input.teacherId) return 'teacher'
  return 'student'
}

export function identifyClarityUser(input: ClarityTagsInput): void {
  if (!isClarityActive()) return

  try {
    window.clarity!('identify', input.userId)

    const role = deriveRole({
      isAdmin: input.isAdmin,
      teacherId: input.teacherId
    })

    const tags: Record<string, string | number | null | undefined> = {
      role,
      entity_id: input.entityId,
      entity_name: input.entityName,
      entity_type: input.entityType,
      root_id: input.rootId,
      root_name: input.rootName,
      entity_degree: input.entityDegree
    }

    for (const [key, value] of Object.entries(tags)) {
      if (value != null && String(value) !== '') {
        window.clarity!('set', key, String(value))
      }
    }
  } catch (error) {
    console.warn('[Clarity] Failed to identify user:', error)
  }
}
